import { defineComponent as _defineComponent } from 'vue'
import { useTranslate } from "@/composables";
import { useCreatorProductStore } from "@/store/creator-products";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendingProductSlidegroup',
  props: {
  profileId: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const { t } = useTranslate();
const title = t("Trending Products");

const trendingProductIds = useCreatorProductStore().trendingProductsFeed[props.profileId]?.ids ?? [];

return { __sfc: true,props, t, title, trendingProductIds }
}

})